<ng-container *ngIf="isShow">
  <div class="l-section u-mt-sp-32 u-mt-tb-40">
    <div class="p-sub-column-layout02__title p-sub-column-layout02__title--has-btn">
      <div class="p-heading-area01" style="max-width: 60%">
        <!-- ボタン　文字折り返し対応 -->
        <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'heading.price1' | staticMsg"></h2>
      </div>
      <asw-button
        id="plan-review-payment-summary-component-open-payment-detail-modal-btn"
        type="tertiary"
        size="xs"
        (click$)="showPaymentDetails()"
        throttleClick
        [disabled]="!isPlanValid"
        [label]="'label.paymentBreakdown' | staticMsg"
      ></asw-button>
    </div>
    <div class="p-sub-column-layout02__body">
      <div class="p-sub-column-layout02__body-item">
        <div class="p-sub-column-layout02__payment" [ngClass]="{ 'grey-bg': !isPlanValid }">
          <div class="p-sub-column-layout02__payment-head">
            <!-- 支払総額～プロモーションコード -->
            <dl class="c-float-list01">
              <!-- ▼ ▼ ▼ プロモーション非適用の場合 ▼ ▼ ▼ -->
              <ng-container *ngIf="!isPromoApplied">
                <div class="c-float-list01__item">
                  <dt
                    class="c-float-list01__title c-float-list01__title--em c-float-list01__contents--fs16 c-float-list01__title--gray90"
                    [innerHTML]="'label.totalAmount' | staticMsg"
                  ></dt>
                  <dd class="c-float-list01__contents c-float-list01__contents--fs16">
                    <span
                      class="c-amount c-amount--price"
                      [ngClass]="{ del: total.type === 'del', diff: total.type === 'diff' }"
                    >
                      <span
                        class="c-amount__num c-amount__num--fs24"
                        [innerHTML]="total.value ?? 0 | amountFormat : undefined : currencyCode"
                      ></span>
                      <span
                        *ngIf="total.type === 'del' || total.type === 'diff'"
                        class="u-visually-hidden"
                        [innerHTML]="'reader.diffIcon' | staticMsg"
                      ></span>
                      <span
                        *ngIf="total.type === 'del'"
                        class="u-visually-hidden"
                        [innerHTML]="'reader.revokedService' | staticMsg"
                      ></span>
                    </span>
                  </dd>
                </div>
              </ng-container>
              <!-- ▼ ▼ ▼ プロモーション適用済みの場合 ▼ ▼ ▼ -->
              <ng-container *ngIf="isPromoApplied">
                <div class="c-float-list01__item">
                  <dt
                    class="c-float-list01__title c-float-list01__title--em c-float-list01__title--gray90"
                    [innerHTML]="'label.totalAmount' | staticMsg"
                  ></dt>
                  <dd class="c-float-list01__contents c-float-list01__contents--fs16">
                    <span
                      class="c-amount c-amount--price"
                      [ngClass]="{ del: total.type === 'del', diff: total.type === 'diff' }"
                    >
                      <span class="u-visually-hidden" [innerHTML]="'label.afterApply' | staticMsg"></span>
                      <span
                        class="c-amount__num c-amount__num--fs24"
                        [innerHTML]="total.value ?? 0 | amountFormat : undefined : currencyCode"
                      ></span>
                      <span
                        *ngIf="total.type === 'del' || total.type === 'diff'"
                        class="u-visually-hidden"
                        [innerHTML]="'reader.diffIcon' | staticMsg"
                      ></span>
                    </span>
                  </dd>
                </div>
                <div class="c-float-list01__item">
                  <dd class="c-float-list01__contents">
                    <span class="u-visually-hidden" [innerHTML]="'label.beforeApply' | staticMsg"></span>
                    <span class="c-amount c-amount--price u-weight-normal">
                      <del
                        [innerHTML]="
                          outputPrices.totalPrices?.discount?.originalTotal ?? 0
                            | amountFormat : undefined : currencyCode
                        "
                      ></del>
                    </span>
                  </dd>
                </div>
                <div class="c-float-list01__item">
                  <!-- プロモーションコード -->
                  <dt class="c-float-list01__title" [innerHTML]="'label.applidPromotion' | staticMsg"></dt>
                  <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                    {{ promoName }}
                  </dd>
                </div>
              </ng-container>
            </dl>
          </div>
          <div class="p-sub-column-layout02__payment-body">
            <dl class="c-float-list01">
              <!-- 運賃総額 -->
              <div *ngIf="!isCA" class="c-float-list01__item">
                <dt class="c-float-list01__title" [innerHTML]="'label.fare' | staticMsg"></dt>
                <dd class="c-float-list01__contents">
                  <span
                    class="c-amount c-amount--price"
                    [innerHTML]="
                      outputPrices.totalPrices?.ticketPrices?.base?.value ?? 0 | amountFormat : undefined : currencyCode
                    "
                  ></span>
                </dd>
              </div>
              <!-- 運賃総額 (フライトサーチャージ併記) -->
              <div *ngIf="isCA" class="c-float-list01__item">
                <dt
                  *ngIf="outputPrices.totalPrices?.ticketPrices?.totalFlightSurcharges"
                  class="c-float-list01__title"
                  [innerHTML]="'lable.fareAndVariousCharge' | staticMsg"
                ></dt>
                <dt
                  *ngIf="!outputPrices.totalPrices?.ticketPrices?.totalFlightSurcharges"
                  class="c-float-list01__title"
                  [innerHTML]="'label.fare' | staticMsg"
                ></dt>
                <dd class="c-float-list01__contents">
                  <span
                    class="c-amount c-amount--price"
                    [innerHTML]="
                      outputPrices.totalPrices?.ticketPrices?.base?.value ?? 0 | amountFormat : undefined : currencyCode
                    "
                  ></span
                  ><br />
                  <span
                    *ngIf="outputPrices.totalPrices?.ticketPrices?.totalFlightSurcharges"
                    class="c-amount c-amount--price"
                    [innerHTML]="
                      'label.parenthesis.n'
                        | staticMsg
                          : {
                              '0':
                                outputPrices.totalPrices?.ticketPrices?.totalFlightSurcharges ?? 0
                                | amountFormat : undefined : currencyCode
                            }
                    "
                  ></span>
                </dd>
              </div>
              <!-- 燃油特別付加運賃等 -->
              <div *ngIf="isCA" class="c-float-list01__item">
                <!-- 燃油特別付加運賃等 -->
                <dt class="c-float-list01__title" [innerHTML]="'lable.fuelSurcharge' | staticMsg"></dt>
                <dd class="c-float-list01__contents">
                  <span
                    class="c-amount c-amount--price"
                    [innerHTML]="
                      outputPrices.totalPrices?.ticketPrices?.airTransportationCharges?.value ?? 0
                        | amountFormat : undefined : currencyCode
                    "
                  ></span>
                </dd>
              </div>
              <!-- 税金総額 -->
              <div *ngIf="!isCA" class="c-float-list01__item">
                <dt class="c-float-list01__title" [innerHTML]="'label.taxFare2' | staticMsg"></dt>
                <dd class="c-float-list01__contents">
                  <span
                    class="c-amount c-amount--price"
                    [innerHTML]="
                      outputPrices.totalPrices?.ticketPrices?.totalTaxes?.value ?? 0
                        | amountFormat : undefined : currencyCode
                    "
                  ></span>
                </dd>
              </div>
              <!-- 各国諸税・空港使用料等 -->
              <div *ngIf="isCA" class="c-float-list01__item">
                <dt class="c-float-list01__title" [innerHTML]="'lable.taxesFeeArges' | staticMsg"></dt>
                <dd class="c-float-list01__contents">
                  <span
                    class="c-amount c-amount--price"
                    [innerHTML]="
                      outputPrices.totalPrices?.ticketPrices?.thirdPartyCharges?.value ?? 0
                        | amountFormat : undefined : currencyCode
                    "
                  ></span>
                </dd>
              </div>
              <!-- 発券手数料 -->
              <div *ngIf="!isCA" class="c-float-list01__item">
                <dt class="c-float-list01__title" [innerHTML]="'label.fee' | staticMsg"></dt>
                <dd class="c-float-list01__contents">
                  <span
                    class="c-amount c-amount--price"
                    [innerHTML]="0 | amountFormat : undefined : currencyCode"
                  ></span
                  ><!-- ※金額ゼロを固定出力 -->
                </dd>
              </div>
              <!-- Ancillaryサービス税抜総額 -->
              <div *ngIf="outputPrices.totalPrices?.servicePrices?.total?.value" class="c-float-list01__item">
                <dt class="c-float-list01__title" [innerHTML]="'label.paidServiceCharges' | staticMsg"></dt>
                <dd class="c-float-list01__contents">
                  <span
                    class="c-amount c-amount--price"
                    [innerHTML]="
                      outputPrices.totalPrices?.servicePrices?.total?.value ?? 0
                        | amountFormat : undefined : currencyCode
                    "
                  ></span>
                </dd>
              </div>
              <!-- Ancillaryサービス税金総額 -->
              <div *ngIf="outputPrices.totalPrices?.servicePrices?.totalTaxes?.value" class="c-float-list01__item">
                <dt class="c-float-list01__title" [innerHTML]="'label.paidServiceTaxAmount' | staticMsg"></dt>
                <dd class="c-float-list01__contents">
                  <span
                    class="c-amount c-amount--price"
                    [innerHTML]="
                      outputPrices.totalPrices?.servicePrices?.totalTaxes?.value ?? 0
                        | amountFormat : undefined : currencyCode
                    "
                  ></span>
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
